import { Map, fromJS } from 'immutable';
import actions from './actions';

// makeSelectLoading,
// makeSelectError,
// makeSelectPropertyList,
// makeSelectPropertyListLoading,
// makeSelectPropertyImages,

// makeSelectPropertyListingData,

// makeSelectPropertyListingPrice,
// makeSelectPropertyListingPaymentData,
// makeSelectPropertyListingPaymentProcessing

const initState = new Map({
  loading: false,
  error: false,
  propertyList: null,
  propertyListLoading: true,
  propertyImages: null,
  propertyListingData: null,

  propertyListingPriceData: null,
  propertyListingPaymentData: null,
  propertyListingPaymentProcessing: false,
  propertySubscriptionData: null,
});

export default function propertiesReducer(state = initState, action) {
  switch (action.type) {
    case actions.DO_LIST_PROPERTY_IMAGES:
      return state
        .set('loading', true);
    case actions.DO_LIST_PROPERTY_IMAGES_SUCCEEDED:
      return state
        .set('loading', false)
        .set('propertyImages', fromJS(action.payload));
    case actions.DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT:
      return state
        .set('propertyListLoading', true);
    case actions.DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT_SUCCEEDED:
      return state
        .set('loading', false)
        .set('propertySubscriptionData', fromJS(action.payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/propertiesSubscribe/reducer.js